import { LOGIN_REQUEST, LOGIN_RESPONSE, LOGIN_ERROR, LOGOUT } from './authActions'

export const initialState = Object.freeze({
    error: '',
    isAuthenticating: false,
    isAuthenticated: false,
    username: '',
    roles: []
})

const actions = {
    [LOGIN_ERROR](state, action) {
        const { reason } = action.payload
        return Object.assign({}, initialState, { error: reason })
    },
    [LOGIN_REQUEST](state, action) {
        return Object.assign({}, initialState, { isAuthenticating: true })
    },
    [LOGIN_RESPONSE](state, action) {
        return Object.assign({}, action.payload, { isAuthenticated: true, isAuthenticating: false })
    },
    [LOGOUT](state, action) {
        return Object.assign({}, initialState, { isAuthenticated: false, isAuthenticating: false })
    }
}

export default function (state = initialState, action) {
    if (actions[action.type]) {
        return actions[action.type](state, action)
    } else {
        return state
    }
}

export const getAuth = (state) => state.auth